import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { ServiceGrid } from "@/components/site/ServiceGrid";

export default function Services() {
  return (
    <>
      <PageHero eyebrow="I nostri servizi" title="Trasporto merci e logistica" text="Soluzioni di trasporto e spedizione per aziende e privati, con tracciamento online di ogni invio." image="/images/forklift.jpg" />
      <section className="bg-black py-24 speed-lines">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ServiceGrid />
          <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border border-white/10 bg-[#14161A] p-8 lg:p-10">
            <div>
              <h3 className="font-display text-2xl sm:text-3xl font-bold uppercase text-white">Hai bisogno di un preventivo?</h3>
              <p className="mt-2 text-slate-400">Descrivici la tua esigenza di trasporto: ti risponderemo il prima possibile.</p>
            </div>
            <Link to="/contatti" className="inline-flex items-center gap-2 bg-[#E50914] hover:bg-[#C10710] text-white px-7 py-4 font-display font-bold uppercase tracking-wider transition-colors shrink-0" data-testid="services-quote-btn">
              Richiedi informazioni <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
